"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnwardsPath = exports.setOnwardsPath = exports.clearUserTokenFromSession = exports.getUserFromSession = exports.storeUserTokenInSession = exports.extractUserFromToken = void 0;
var jsonwebtoken_1 = require("jsonwebtoken");
var container_1 = require("../../ioc/container");
var ApiAdapter_1 = require("../../adapters/ApiAdapter");
/**
 * Extracts the user payload from the auth JWT
 *
 * @param token
 * @returns
 */
var extractUserFromToken = function (token) {
    var _a;
    var user = (_a = jsonwebtoken_1.decode(token)) === null || _a === void 0 ? void 0 : _a.user;
    return user;
};
exports.extractUserFromToken = extractUserFromToken;
/**
 * Stores a user token in session storage
 *
 * @param token
 * @param storageKey
 */
var storeUserTokenInSession = function (token, storageKey) {
    sessionStorage.setItem(storageKey, token);
    // Update the ApiAdapter to use this token
    container_1.getCoreContainer().get(ApiAdapter_1.ApiAdapter).setAuthenticationToken(token);
};
exports.storeUserTokenInSession = storeUserTokenInSession;
/**
 * Gets a user object from the stored session JWT
 */
var getUserFromSession = function (storageKey) {
    return exports.extractUserFromToken(sessionStorage.getItem(storageKey));
};
exports.getUserFromSession = getUserFromSession;
var clearUserTokenFromSession = function (storageKey) {
    sessionStorage.removeItem(storageKey);
};
exports.clearUserTokenFromSession = clearUserTokenFromSession;
/**
 *
 * @see getOnwardsPath()
 * @param storageKey
 * @param path
 */
var setOnwardsPath = function (storageKey, path) {
    sessionStorage.setItem(storageKey + '-onwards', path);
};
exports.setOnwardsPath = setOnwardsPath;
/**
 * The onward path is where the user is trying to get to. We store
 * this in sessionStorage because some login journies are oAuth redirects
 * away from the site and back again.
 */
var getOnwardsPath = function (storageKey) {
    var path = sessionStorage.getItem(storageKey + '-onwards');
    if (path[0] == '/') {
        // We must check the onwards path is not any kind of absolute URL that could be
        // used for login spoofing.
        return path;
    }
    return '';
};
exports.getOnwardsPath = getOnwardsPath;
//# sourceMappingURL=SessionUtils.js.map